export const SELECT_MENU_FOR_GRID = 'SELECT_MENU_FOR_GRID';
export const GRID_CONFIGURATION = 'GRID_CONFIGURATION';
export const SELECT_COL = 'SELECT_COL';
export const SELECT_ROW = 'SELECT_ROW';
export const SELECT_IMAGE = 'SELECT_IMAGE';
export const SELECT_GRID_ITEM = 'SELECT_GRID_ITEM';
export const SELECT_GRID_TEMPLATE_AREA = 'SELECT_GRID_TEMPLATE_AREA';
export const UPDATE_MENU_GRID_CONFIGURATION_SUCCESS = 'UPDATE_MENU_GRID_CONFIGURATION_SUCCESS';
export const SELECT_CACHE = 'SELECT_CACHE';
export const SELECT_PADDING_GRID = 'SELECT_PADDING_GRID';
export const UPDATE_MENU_GRID_ITEM_CONFIGURATION = 'UPDATE_MENU_GRID_ITEM_CONFIGURATION';
export const SELECT_ASPECT_RATIO = 'SELECT_ASPECT_RATIO';
export const SELECT_BACKGROUND_IMAGE_SIZE_BEHAVIOUR = 'SELECT_BACKGROUND_IMAGE_SIZE_BEHAVIOUR';
export const SELECT_MENU_GRID_ITEM_LIST = 'SELECT_MENU_GRID_ITEM_LIST';
export const SELECT_CLAUSE_LIST = 'SELECT_CLAUSE_LIST';
export const SELECT_MENU_GRID_ITEM_CONFIGURATION = 'SELECT_MENU_GRID_ITEM_CONFIGURATION';
export const GRID_ITEM_TO_DELETE = 'GRID_ITEM_TO_DELETE';
export const SET_OPEN_PORTAL = 'SET_OPEN_PORTAL';
